import Model from './model.js';

export default class AdministrativeData extends Model
{
    constructor(id, personId, placeAffiliation, almelak, position, levelOne, levelTwo, levelThree, note){ 
        super()
        this.id                 = id ?? 0;
        this.personId           = personId;
        this.placeAffiliation   = placeAffiliation;
        this.almelak            = almelak;
        this.position           = position;
        this.levelOne           = levelOne;
        this.levelTwo           = levelTwo;
        this.levelThree         = levelThree;
        this.note              = note;

        this.init()
    }

    update(data){
        Object.assign(this, data)
    }
    
    mapToCreate(){
        let data = this.mapToUpdate();
        data.person_id = this.personId ?? null;
        return data;
    }

    mapToUpdate(){
        const level = Number(this.position?.level ?? 0)

        return {
            placeAffiliation_id:    this.placeAffiliation?.value ?? null,
            almelak_id:             this.almelak?.value ?? null,
            position_id:            this.position?.value ?? null,
            levelOne_id:            level >= 1 ? (this.levelOne?.value ?? null) : null,
            levelTwo_id:            level >= 2 ? (this.levelTwo?.value ?? null) : null,
            levelThree_id:          level >= 3 ? (this.levelThree?.value ?? null) : null,
            notes:                  this.note ?? null
        }
    }
}

